<input pInputText
       id="text"
       #text="ngModel"
       type="text"
       [required]="column.validation?.isRequired === true"
       [maxlength]="column.validation?.maxLength || null"
       [(ngModel)]="record[column.field]" />

<div *ngIf="text.invalid && (text.dirty || text.touched)"
     class="alert">
  <div *ngIf="text.errors?.['required']">
    Required.
  </div>
  <div *ngIf="text.errors?.['minlength']">
    Must be at least 4 characters long.
  </div>
  <div *ngIf="text.errors?.['maxlength'] && column.validation?.maxLength">
    Max {{ column.validation?.maxLength }} characters long.
  </div>
</div>
